// Generated by `yarn tokens:import --aos-ds` from the Figma "Transparent" variables export. Do not edit.
//
// Keys are Figma's own aliases, holding the raw number Figma stores, in
// whatever unit that collection uses. `tailwind-preset.js` turns them into
// the Tailwind scale, so a class name and a Figma token are the same word.

export const transparent = {
    disabled: 40,
} as const

export type TransparentAlias = keyof typeof transparent
